import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import React, { useEffect, useRef, useState } from "react";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import "../style.css";
import uuidv4 from "uuid/v4";
// import ArticleRow from "./articleRow";
import TableComplex from "../../../vapor/tableComplex";
import { columnsContiContabili } from "./columns";
import {
  createAccountingLine,
  deleteAccountingGroupLine,
  getAccountArticles
} from "../../../../store/actions/precog/accountingLines";
import {
  getVatLines
} from "../../../../store/actions/precog/vat";
import { FormattedMessage } from "react-intl";
import AutocompleteSelector from "../../../general/autocompleteSelector/autocomplete";
import DrawerDetail from "./drawerDetail";
import { getCurrencyList } from "../../../../store/actions/currency";
import InfiniteScroll from "react-infinite-scroller";
import LoaderSimple from "../../../general/loader";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./style.css";
import { getDetailAccounts, getInvoiceDetail, searchAccounts } from "../../../../store/actions/precog";
import SplitArticleModal from "./splitArticleModal";
import { clearResizeWidth, getGroupId, onResizeWidthChange } from "./methods";
import ArticleRowNew from "./articleRow/index";
import { VaporRangeDatePicker } from "../../../vapor";
import moment from "moment";
import ModalNature from "./modalNature";

const ContiContabiliTable = ({
  contiContabili,
  contiNew,
  setContiNew,  
  // setResidue,
  debitTotal,
  creditTotal,
  setDebitTotal,
  setCreditTotal, 
  newDetail,  
  setModifiedDetail,
  isMonoRegime,
  setDragArticleConto,
  dragArticleConto,
  setIsCreatingNewLine,
  setIsClosingDrawer,
  setContoSelected,
  contoSelected
}) => {
  const dispatch = useDispatch();
  const jsonCurrency = useSelector(state => state?.currencyList?.currencies);
  // const rates = useSelector(state => state.precog.vat.rates.list);
  const accountsLoaded = useSelector(state => state.precog.detailAccounts.status?.started);
  const detailLoaded = useSelector(state => state.precog.updatedDetail.status?.ended);
  const accountArticles = useSelector(state => state.precog.accountArticles.data);
  const accountArticlesStatus = useSelector(state => state.precog.accountArticles.status);
  const searchedAccounts = useSelector(state => state.precog.searchAccounts.data);
  const accountsToRefresh = useSelector(state => state.precog.detailAccounts.status?.isToRefresh);

  // const [showPopover, setShowPopover] = useState({ id: "", visible: false });  
  const [currentItem, setCurrentItem] = useState({
    currentLine: "",
    currentArticle: ""
  });
  const [draggingFrom, setDraggingFrom] = useState(false);
  const [allowDrag, setAllowDrag] = useState(false);
  const [lockDrag, setLockDrag] = useState(false);
  const [droppingOn, setDroppingOn] = useState(null);
  const [drawerDetail, setDrawerDetail] = useState(null);
  const [expandedRow, setExpandedRow] = useState([]);
  const [currentArticles, setCurrentArticles] = useState([]);
  const [page, setPage] = useState(0);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [openSplitModal, setOpenSplitModal] = useState(false);
  const [resizeContoId, setResizeContoId] = useState(null);
  const [articlesList, setArticlesList] = useState([]);
  const [currentIsPosting, setCurrentIsPosting] = useState(false);
  const [dates, setDates] = useState([]);
  const [drawerNature, setDrawerNature] = useState(false);
  const [natureVal, setNatureVal] = useState([]);
  const [isDrawerToClose, setIsDrawerToClose] = useState(false);

  const containerArticlesRef = useRef([]);
  const arrayToExpand = ["FE1", "FE4", "FE401", "FE5", "FE8", "FE9", "FE10", "CO1", "FA1", "FA3", "FA4", "FA401", "FA5", "FA7", "FA8"];

  useEffect(() => {
    /** dato che in registrazione manuale si può cambiare la currency,
   *  devo avere la lista disponibile */
    
    dispatch(searchAccounts(""));
    if (!jsonCurrency)
      dispatch(getCurrencyList());
  }, []);

  useEffect(() => {
    // initiate the event handler
    window.addEventListener("resize", onResizeCheck);
    // this will clean up the event every time the component is re-rendered
    return function cleanup() {
      window.removeEventListener("resize", onResizeCheck);
    };
  });

  useEffect(() => {
    if (!accountArticlesStatus) return;
    if (accountArticlesStatus.ended && resizeContoId) {
      setTimeout(() => {
        onResizeWidthChange(resizeContoId);
      }, 500);
    }
  }, [accountArticlesStatus]);

  function resizedw() {
    onResizeWidthChange(resizeContoId);
  }

  const onResizeCheck = () => {
    let doit;
    clearTimeout(doit);
    const colsWidth = newDetail?.reasonId === "CO1" ? ["3%", "21%", "20%", "6.5%", "8%", "6.5%", "15%", 150, 72] : ["4%", "45%", "10%", "8%", "10%", "6.5%", "6.5%", "7%", "4%"];

    clearResizeWidth(resizeContoId, colsWidth);
    doit = setTimeout(function() {
      resizedw();
    }, 200);
  };

  useEffect(() => {
    if (!accountArticles){
      setCurrentArticles([]);
    } else {
      setCurrentArticles(accountArticles.elements);
    }
  }, [accountArticles]);

  useEffect(() => {
    if (!expandedRow) return undefined;
    // ricordarsi di modificare se si dovranno aprire più righe contemporaneamente
    const refIndex = contiNew.findIndex(el => el.uuid === expandedRow[0]);
    if (refIndex === -1 || !containerArticlesRef.current?.[refIndex]) return undefined;
    let ps = new Scrollbar(containerArticlesRef.current[refIndex], {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [containerArticlesRef.current, expandedRow]);

  useEffect(() => {
    let conti = [];
    
    if (contiContabili?.accountingLinesByCodeApiResList) {
      // let newConti = mergeAccountingLines(contiContabili, rates);
      contiContabili?.accountingLinesByCodeApiResList?.map(el => {
        const str = el?.accountDesc?.toLowerCase();
        const str2 = str ? str?.charAt(0)?.toUpperCase() + str?.slice(1) : str;
        conti.push({
          ...el,
          compoundedTitle: str2,
          endPeriodDate: el.endPeriodDate ? el.endPeriodDate : "",
          startPeriodDate: el.startPeriodDate ? el.startPeriodDate : "",
          rowId: uuidv4()
        });
        return conti;
      });
    }
    setContiNew(conti);
  }, [JSON.stringify(contiContabili?.accountingLinesByCodeApiResList)]);

  useEffect(() => {
    if (!isMonoRegime || !currentRecord || !detailLoaded) return;
    getArticles(expandedRow, currentRecord);
  }, [isMonoRegime, detailLoaded]);

  const calcTotals = () => {

    let debitSum = 0;
    let creditSum = 0;
    if (contiNew) {
      contiNew.map(el => {
        debitSum = debitSum + el.debit;
        creditSum = creditSum + el.credit;
        return null;
      });
    }
    setDebitTotal(Math.round(debitSum * 100)/100);
    setCreditTotal(Math.round(creditSum * 100)/100);
    // setResidue(Math.round(creditSum * 100)/100 - Math.round(debitSum * 100)/100);
  };

  const loadMoreItems = uuid => {
    if (!accountArticles?.hasNext || accountArticlesStatus?.started) return;
    const currentPage = page;

    dispatch(getAccountArticles(
      newDetail.id, uuid, page
    )).then(res => {
      if (res.data.hasNext) {
        setPage(currentPage + 1);
      }
    });
  };

  useEffect(() => {
    if (!contiNew || contiNew.length === 0) return;
    calcTotals();
    /** I want to expand the first account with children when the contiNew changes */    
    if (expandedRow?.length === 0) {
      let recordWithChild = contiNew.find(el => el.hasChildren);
      if (!recordWithChild && newDetail.source !== "B2B" && contiNew[0].accountCode !== "" && contiNew[0].isPosting) {
        recordWithChild = contiNew[0];
      }
      if (recordWithChild) {
        const recordToExpand = renderTableRow(recordWithChild, recordWithChild?.uuid);
        setCurrentRecord(recordToExpand);
        setExpandedRow([recordToExpand?.conto?.uuid]);
        if (!currentArticles || currentArticles.length === 0) {
          getArticles(true, recordToExpand);
        }
        setResizeContoId(recordToExpand?.conto?.uuid);  
      }
    } 
  }, [contiNew]);

  const onDragArticleEnd = (dropData, conto) => {
    /** TODO per ora ricarica la tabella ma non so come riaprire il record dato che la
     * chiave cambia
     */
    const newAccount = contiNew.find(el => el.uuid === dropData.to);
    
    setModifiedDetail({ accountingLine: [dropData.article.uuid], modifiedData: { accountCode: newAccount?.accountCode, destinationGroupId: dropData.to } });
    // dobbiamo refreshare quindi pagina la settiamo a 0
    setPage(0);
    setTimeout(() => {      
      const newKeyToExpand = getGroupId(
        newAccount?.accountCode, newAccount?.debit, newAccount?.credit
      );
      setExpandedRow([]);
      setDragArticleConto([newKeyToExpand]);
      dispatch(getAccountArticles(
        newDetail.id, newKeyToExpand, 0
      )).then(res => {

        setPage(1);
      });
    }, 500);

    return;
  };

  const onRemoveConto = rowId => {
    const contoToRemove = contiNew.find(el => el.rowId === rowId);
    const contoToRemoveUUId = contoToRemove?.uuid;

    if (contoToRemoveUUId) {
      dispatch(deleteAccountingGroupLine(newDetail.id,
        contoToRemoveUUId)).then(res => {
        const filterContiRemoved = contiNew.filter(el => el.rowId !== rowId);
        setContiNew(filterContiRemoved);

        // refresh all detail because can change "imponibile"
        dispatch(getInvoiceDetail(newDetail.id));
      });
    } else {
      const filterContiRemoved = contiNew.filter(el => el.rowId !== rowId);
      setContiNew(filterContiRemoved);
    }

    // checkModified(items);
  }; 

  const onAddItemClick = () => {
    let items = [];
    contiNew.map(item => {
      return items.push(item);
    });
    let newItem = {
      accountCode: "",
      accountDesc: "",
      debit: 0,
      credit: 0,
      currency: "",
      nonDeductibleVATRate: null,
      vatDestinationId: null
    };
    newItem = { ...newItem, rowId: uuidv4() };
    items.push(newItem);
    setContiNew(items);
  };

  const onChangeArticle = (article, index) => {
    let contiToUpdate = [...contiNew];
    let contoToChange = contiToUpdate.find(el => el.uuid === expandedRow[0]);
    if (article.type === "credit" || article.type === "debit") {
      let total = 0;
      currentArticles.map(el => {
        if (el.uuid === article.uuid) {
          total += article.value;
        } else {
          total += el?.[article.type];
        }
      });
      if (currentArticles.length === 1) {
        let newUuid = getGroupId(
          contoToChange.accountCode, article.type === "debit" ? article.value : 0, article.type === "credit" ? article.value : 0
        );
        contoToChange["uuid"] = newUuid;
      }
      contoToChange[article.type] = total;
    }
    let totalToChange = 0;
    if (newDetail.reasonId === "CO1") {
      totalToChange = currentArticles.reduce((a, b) => {
        return a + (b.credit + (b.credit * b.vatRate)/100);
      }, 0);
    }
    setContiNew(contiToUpdate);
    if (Array.isArray(article.type)) {
      let modified = {};
      article.type.map((el, index) => {
        return modified = { ...modified, [el]: article.value[index] };
      });
      setModifiedDetail({ parentId: contoToChange.uuid, totalAmountForCO1: totalToChange, accountingLine: [article.uuid], modifiedData: modified });
    } else {
      setModifiedDetail({parentId: contoToChange.uuid, totalAmountForCO1: totalToChange, accountingLine: [article.uuid], modifiedData: {[article.type]: article.value}});
    }
  };

  const getArticles = (expanded, record) => {
    const keys = [];
    setPage(0);
    setDragArticleConto(null);
    /** La getArticles la fa solo all'expand per far quadrare tutto portiamo la pagina a 0 sempre */
    if (expanded) {
      keys.push(record.conto?.uuid || record.key);
      if (record.conto?.hasChildren) {
        dispatch(getAccountArticles(
          newDetail.id, record.conto?.uuid, 0
        )).then(res => {
          setPage(page +1);
        });
      } else {
        setCurrentArticles([]);
      }
      setExpandedRow(keys);
      
    } else {
      // clear
      setExpandedRow(null);
    }
  };

  const natureChange = (
    val, label, idx
  ) => {
    if (drawerNature.isSplitModal && idx !== 0) {
      let newArticlesList = [];
      articlesList.map((el, index) => {
        if (index !== idx) {
          newArticlesList.push(el);
        } else {
          newArticlesList.push({ ...el, exemptionNatureId: val, exemptionNature: label});
        }
      });
      setArticlesList(newArticlesList);
    }
    let newCurrent = [...currentArticles];
    let itemToChange = newCurrent.find(el => el.uuid === currentItem.currentArticle.uuid);
    itemToChange.exemptionNatureId = val;
    itemToChange.exemptionNature = label;
    setCurrentArticles(newCurrent);
    onChangeArticle({ uuid: drawerNature?.rowId ? drawerNature?.rowId : currentItem.currentArticle.uuid , type: ["exemptionNatureId", "exemptionNature"], value: [val, label] }, idx);
    let natures = [];
    if (natureVal.find(el => el.article === currentItem.currentArticle.uuid)) {
      natures = natureVal.map(el => {
        if (el.article === currentItem.currentArticle.uuid) {
          return {...el, nature: label, natureId: val};
        }
        return el;
      });
    } else {
      natures.push({ article: currentItem.currentArticle.uuid, natureId: val, nature: label });
    }
    setNatureVal(natures);
    setDrawerNature(null);
  };

  const renderTableRow = (conto, key) => {
    if (conto.startPeriodDate && conto.endPeriodDate) {
      setDates([moment.unix(conto.startPeriodDate), moment.unix(conto.endPeriodDate)]);
    } else if (conto.startPeriodDate) {
      setDates([moment.unix(conto?.startPeriodDate), null]);
    } else if (conto.endPeriodDate) {
      setDates([null, moment.unix(conto.endPeriodDate)]);
    }
    
    return {
      key: conto?.rowId || `rowID_${key}`,
      conto: conto,
      contoContabile: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AutocompleteSelector
            disabled={conto?.disabled}
            includeSystem={false}
            overlayClassName="accounting-accounts-popover"
            className="fontFiveH"
            popoverPlacement="bottom"
            isAccountingAccounts={true}
            singlePopover={true}
            style={{fontWeight: 500}}
            placeholder={"Inizia a scrivere per cercare un conto"}
            rowId={conto?.rowId || `rowID_${key}`}
            initialValue={conto?.compoundedTitle}
            value={conto?.compoundedTitle}
            onSearch={(val) => {
              const cloneConti = [...contiNew];              
              const currentRow = cloneConti.find(obj => obj.rowId === (conto?.rowId || `rowID_${key}`));
              
              currentRow.compoundedTitle = val; 
              setContiNew(cloneConti);
            }}
            onChange={(el => {
              const cloneConti = [...contiNew];
              const currentRow = cloneConti.find(obj => obj.rowId === el.rowId);              
              const currentSearched = searchedAccounts?.accounts.find(search => search?.code === el?.code?.trim());
              currentRow.compoundedTitle = el?.title;
              if (currentRow.accountCode === "" && el?.onSelect) {
                currentRow.accountDesc = el?.title?.trim();
                currentRow.accountCode = el?.code?.trim();
                currentRow.accountType = currentSearched?.type;
                const objToCreate = newDetail.source !== "B2B" && ( newDetail.factType.toLowerCase() === "invoice" || newDetail.factType.toLowerCase() === "receipt")  ? 
                  { ...currentRow, accountCode: el?.code?.trim(), articleDesc: "Descrizione", vatRate: "22.0" } : 
                  { ...currentRow, accountCode: el?.code?.trim()};
                dispatch(createAccountingLine(newDetail.id, objToCreate))
                  .then(res => {
                    currentRow.uuid = res.uuid;
                    setContiNew(cloneConti);
                    setIsCreatingNewLine(res.uuid);
                    dispatch(getInvoiceDetail(newDetail.id));
                  });
              } else {
                if (el.code && el?.onSelect) {
                  const newCode = getGroupId(
                    el?.code?.trim(), currentRow.debit, currentRow.credit
                  );
                  currentRow.accountDesc = el?.title?.trim();
                  currentRow.accountCode = el?.code?.trim();
                  currentRow.accountType = currentSearched?.type;
                  setModifiedDetail({ accountingLine: currentRow.uuid, modifiedData: { accountCode: currentRow.accountCode }, newCode: newCode });
                  currentRow.uuid = newCode;
                  setContiNew(cloneConti);
                }
              }
            })}
            vapor={true}
          />
          {conto?.accountType && (
            <div
              className="conti-contabili-type-container"
              style={{
                background:
                  conto?.accountType === "INCOME_STATEMENT" ? "#0d6c80" : "#753f83"
              }}
            >
              {conto?.accountType === "INCOME_STATEMENT" ? "E" : "P"}
            </div>
          )}
        </div>
      ),
      regime: (conto?.articles) ? (
        <div className="conti-contabili-iva-titles"><FormattedMessage id="preCog.accountingTab.regime" /></div>
      ) : (
        ""
      ),
      aliquota: conto?.articles ? (
        <div className="conti-contabili-iva-titles"><FormattedMessage id="preCog.accountingTab.rate" /></div>
      ) : (
        ""
      ),
      previousBalance: conto?.previousBalance,
      currency: " " + (jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol || "€"),
      // (<div>
      //     {conto.vatRate ? `${parseInt(conto.vatRate)}%` : "-"}
      //   </div>
      // ),
      destinazione: conto?.articles ? (
        <div className="conti-contabili-iva-titles"><FormattedMessage id="preCog.accountingTab.destination" /></div>
      ) : (
        ""
      ),
      dare: (
        <NumberFormat
          displayType={"input"}
          thousandSeparator={"."}
          decimalSeparator={","}
          className="conti-contabili-credit"
          placeholder="-"
          disabled={arrayToExpand.includes(newDetail.reasonId) && (conto?.hasChildren || newDetail?.source === "B2B" && conto?.hasChildren || conto?.disabled || newDetail?.source !== "B2B")}
          suffix={" " + (jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol || "€")}
          value={
            conto?.debit !== 0
              ? numeral(Math.abs(conto?.debit)).format("0,0.00")
              : ""
          }
          onBlur={e => {
            if (contiNew.find(el => el.uuid === conto?.uuid)) {
              let itemIndex = contiNew
                .map(item => item.uuid)
                .indexOf(conto?.uuid);
              setModifiedDetail({accountingLine: contiNew.find(x => x.uuid === contiNew[itemIndex].uuid).uuid, modifiedData: {debit: contiNew[itemIndex].debit}});
            } else {
              let itemIndex = contiNew
                .map(item => item.uuid)
                .indexOf("");
              setModifiedDetail({accountingLine: [contiNew.find(x => x.uuid === contiNew[itemIndex].uuid)]});
            }
          }}
          onChange={e => {
            if (contiNew.find(el => el.uuid === conto?.uuid)) {
              let itemIndex = contiNew
                .map(item => item.uuid)
                .indexOf(conto?.uuid);
              const debit = e.target.value
                ? parseFloat(e.target.value.replace(".", "").replace(",", "."))
                : 0;
              contiNew[itemIndex].debit = debit;
            } else {
              let itemIndex = contiNew
                .map(item => item.uuid)
                .indexOf("");
              contiNew[itemIndex].debit = e.target.value
                ? parseFloat(e.target.value.replace(".", "").replace(",", "."))
                : 0;
            }
            calcTotals();
          }}
        />
      ),
      avere: (
        <NumberFormat
          allowLeadingZeros={true}
          displayType={"input"}
          thousandSeparator={"."}
          decimalSeparator={","}
          className="conti-contabili-debit"
          placeholder="-"
          disabled={arrayToExpand.includes(newDetail.reasonId) && (conto?.hasChildren || newDetail?.source === "B2B" && conto?.hasChildren || conto?.disabled || newDetail?.source !== "B2B")}
          suffix={" " + (jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol || "€")}
          value={
            conto?.credit !== 0
              ? numeral(Math.abs(conto?.credit)).format("0,0.00")
              : ""
          }
          onBlur={e => {
            if (contiNew.find(el => el.uuid === conto?.uuid)) {
              let itemIndex = contiNew
                .map(item => item?.uuid)
                .indexOf(conto?.uuid);
              setModifiedDetail({accountingLine: contiNew.find(x => x.uuid === contiNew[itemIndex].uuid).uuid, modifiedData: {credit: contiNew[itemIndex].credit}});
            } else {
              let itemIndex = contiNew
                .map(item => item.uuid)
                .indexOf("");
              setModifiedDetail({accountingLine: [contiNew.find(x => x.uuid === contiNew[itemIndex].uuid)]});
            }
          }}
          onChange={e => {
            if (contiNew.find(el => el.uuid === conto?.uuid)) {
              let itemIndex = contiNew
                .map(item => item.uuid)
                .indexOf(conto?.uuid);
              const credit = e.target.value
                ? parseFloat(e.target.value.replace(".", "").replace(",", "."))
                : 0;
              contiNew[itemIndex].credit = credit;
            } else {
              let itemIndex = contiNew
                .map(item => item.uuid)
                .indexOf("");
              contiNew[itemIndex].credit = e.target.value
                ? parseFloat(e.target.value.replace(".", "").replace(",", "."))
                : 0;
            }
            calcTotals();
          }}
        />
        
      ),

      inizioCompetenza: (conto?.accountType === "INCOME_STATEMENT" && newDetail.source !== "B2B" &&
        <VaporRangeDatePicker
          value={dates}
          className="conti-contabili-date"
          allowEmpty={[true, true]}
          customTrigger={true}
          onChange={value => {
            if (!value) {
              setDates([null, null]);
              setModifiedDetail({accountingLine: conto.uuid, modifiedData: {fieldsToDelete: ["startPeriodDate", "endPeriodDate"] }});
              // onArticleChange("fieldsToDelete", ["startPeriodDate", "endPeriodDate"]);
            } else {
              setDates([value[0], value.length > 1 ? value[1] : null]);
              setModifiedDetail({accountingLine: conto.uuid, modifiedData: {startPeriodDate: value[0], endPeriodDate:  value.length > 1 ? value[1] : null }});
              // onArticleChange(["startPeriodDate", "endPeriodDate"], [value[0], value.length > 1 ? value[1] : null]);
            }
          }}
        />),
      amountWithVat: (<div>{numeral(Math.abs(conto?.amountWithVat)).format("0,0.00")} {(jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol || "€")}</div>),
      contoDetail: (
        <div
          onClick={() => { 
            setDrawerDetail(conto?.uuid); 
            setExpandedRow([]);
            setCurrentIsPosting(conto?.isPosting); 
          }}
          style={{ paddingRight: 10 }}
        >
          <FontAwesomeIcon
            className="preCog-detail-remove-icon"
            icon={["far", "external-link-square-alt"]}
          />
        </div>
      ),
      removeConto: ((newDetail.source === "B2B" && !conto?.hasChildren && !conto?.disabled) || (newDetail.source !== "B2B" && !conto?.disabled) || !conto?.uuid) && (
        <div
          onClick={() => onRemoveConto(conto?.rowId)}
          style={{ paddingRight: 10 }}
        >
          <FontAwesomeIcon
            className="preCog-detail-remove-icon"
            icon={["far", "trash-alt"]}
          />
        </div>
      )
    };
  };

  const addNewArticle = (conto) => {
    let newItem = {
      accountCode: conto?.accountCode,
      credit: 0,
      debit: 0,
      endPeriodDate: conto?.endPeriodDate,
      startPeriodDate: conto?.startPeriodDate      
    };
    /** Solo su fatture devo poter aggiungere una riga di imponibile */
    newItem = newDetail.source !== "B2B" && ( newDetail.factType.toLowerCase() === "invoice" || newDetail.factType.toLowerCase() === "receipt") ? {...newItem, articleDesc: "Descrizione",
      vatRate: "22.0"} : newItem;
    dispatch(createAccountingLine(
      newDetail.id, newItem, conto?.uuid
    )).then(res => {
      let current = Array.isArray(currentArticles) ? currentArticles : [];
      current.push({ ...newItem, uuid: res.uuid });
      setCurrentArticles(current);
      let currentDebit = 0;
      let currentCredit = 0;
      currentArticles.map(el => {
        currentDebit += el.debit || 0;
        currentCredit += el.credit || 0;
      });
      let newContoId = getGroupId(
        conto?.accountCode, currentDebit, currentCredit 
      );
      
      dispatch(getDetailAccounts(newDetail.id)).then(() => {
        dispatch(getAccountArticles(
          newDetail.id, newContoId, 0
        ));
        dispatch(getVatLines(newDetail.id));
      });
     
    });
  };

  const buildDataSource = () => {
    return contiNew?.map((conto, key) => renderTableRow(conto, key));
  };

  const renderSummary = () => {
    let totalForCO1 = contiNew.length > 0 ? contiNew.reduce((a, b) => {
      return (typeof a === "object" ? a?.amountWithVat : a) + b?.amountWithVat;
    }, 0) : 0;
    
    let itemsRet = newDetail?.reasonId === "CO1" ? [
      <div key={"conti-contabili-add_summary"} className="conti-contabili-add" onClick={() => onAddItemClick()}>
        <FontAwesomeIcon icon={["fas", "plus-circle"]} />
      &nbsp;Aggiungi conto contabile
      </div>,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      <div key={"preCog-detail-table-summary-total2"}  className="preCog-detail-table-summary-totals">
        {numeral(Math.abs(totalForCO1)).format("0,0.00") + " " + (jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol || "€")}
      </div>

    ] :
      [
        <div key={"conti-contabili-add_summary"} className="conti-contabili-add" onClick={() => onAddItemClick()}>
          <FontAwesomeIcon icon={["fas", "plus-circle"]} />
        &nbsp;Aggiungi conto contabile
        </div>,
        "",
        "",
        "",
        "",
        <div key={"preCog-detail-table-summary-total1"} className="preCog-detail-table-summary-totals">
          {numeral(Math.abs(creditTotal)).format("0,0.00") + " " + (jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol || "€")}
        </div>,
        <div key={"preCog-detail-table-summary-total2"}  className="preCog-detail-table-summary-totals">
          {numeral(Math.abs(debitTotal)).format("0,0.00") + " " + (jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol || "€")}
        </div>,
        "",
        Math.round(creditTotal * 100)/100 !== Math.round(debitTotal * 100)/100 ? (
          <div className="preCog-detail-table-summary-residue">{`Residuo: ${numeral(Math.abs((Math.round(creditTotal * 100)/100) - (Math.round(debitTotal * 100)/100 ))).format("0,0.00")}`}</div>
        ) : (
          <div style={{ textAlign: "center" }}>
            <FontAwesomeIcon
              icon={["fas", "check"]}
              className="preCog-detail-check-icon"
            />
          </div>
        )
      ];

    if (creditTotal !== debitTotal) {
      itemsRet.splice(5, 1);
    }
    // il tasto + lo mostro solo se ho il draftId altrimenti va in errore
    return newDetail?.id ? itemsRet : null;
  };
  
  const isSpinnerToShow = accountsToRefresh ? (accountsLoaded && contiNew.length === 0 && accountsToRefresh) : (accountsLoaded && contiNew.length === 0);
  const loader = (
    <div
      style={{ position: "sticky", top: "50vh", /* top: "64px", */
        backgroundColor: "rgba(256,256,256, 0.7)", 
        width: "calc(100% - 64px)",
        height: "calc(100% - 64px)",
        zIndex: 9,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center", fontSize: "32px", color: "#0090d1", left: "64px" }}
    >
      <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
    </div>
  );
  
  return (
    <>
      {isSpinnerToShow ? <LoaderSimple /> :
        <div className="conti-contabili-table-new">
          {drawerDetail && (
            <DrawerDetail
              docDate={newDetail?.doc?.date}
              isMonoRegime={isMonoRegime}
              invoiceId={newDetail.id}
              contiNew={contiNew}
              visible={drawerDetail}
              onChange={val => {
                setDrawerDetail(null);
              }}
              setIsDrawerToClose={setIsDrawerToClose}
              setModifiedDetail={setModifiedDetail}
              closeFunction={() => {
                if (isDrawerToClose) {
                  setIsClosingDrawer(true);
                }
                setDrawerDetail(null);
                dispatch({type: "STOP_ACCOUNTS_REFRESH"});
                dispatch(getVatLines(newDetail.id));
                
                dispatch(getDetailAccounts(newDetail.id)).then(() => {
                  dispatch({ type: "SET_ACCOUNTS_REFRESH" });
                  dispatch(getAccountArticles(
                    newDetail.id, contoSelected, 0
                  ));
                  setExpandedRow([contoSelected]);
                });
              }}
              setContiNew={setContiNew}
              expandedRow={expandedRow}
              setExpandedRow={setExpandedRow}
              setPage={setPage}
              page={page}
              loadMoreItems={loadMoreItems}
              refCurrency={jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol || "€"}
              currentIsPosting={currentIsPosting}
              contoSelected={contoSelected}
              setContoSelected={setContoSelected}
            />
          )}
          {drawerNature && (
            <ModalNature
              visible={drawerNature}
              initialValue={drawerNature?.article?.exemptionNature}
              onChange={(val, label) => {
                natureChange(
                  val, label, drawerNature.index
                );
              }}
              onClose={() => setDrawerNature(null)}
            />
          )}
          <div className="contiContabiliTable">
            <TableComplex            
              summary={renderSummary()}
              dataSource={buildDataSource()}
              locale={{ emptyText: (<span></span>)
              }}
              columns={columnsContiContabili(
                draggingFrom, setDroppingOn, newDetail?.regimeId, newDetail?.reasonId
              )}
              rowClassName={(record, index) => {
                return record.conto?.uuid === droppingOn
                  ? " precog-highlighted"
                  : "";
              }}
              expandable={{
                // expandIconColumnIndex: -1,
                defaultExpandedRowKeys: dragArticleConto,
                expandedRowKeys: expandedRow,
                rowExpandable: record => arrayToExpand.includes(newDetail.reasonId) ? true : newDetail.source !== "B2B" ? true : record.conto?.hasChildren,
                onExpand: (expanded, record) => {
                  setCurrentRecord(record);
                  getArticles(expanded, record);
                  setResizeContoId(record?.conto?.uuid);
                },
                expandIcon: ({ expanded, onExpand, record }) => 
                  (arrayToExpand.includes(newDetail.reasonId) && (newDetail.source !== "B2B" || record.conto?.hasChildren) && record?.conto?.isPosting) &&
                    <div style={{ padding: "8px" }} onClick={e => onExpand(record, e)}>
                      <FontAwesomeIcon
                        icon={[
                          "far",
                          expanded ? "chevron-down" : "chevron-right"
                        ]}
                        className="conti-contabili-expand-icon"
                      /></div>,
                expandedRowRender: (record, index) => {
                  let cn = -1;        
                  const isLoadingSpinner = accountsToRefresh ? (accountArticlesStatus?.started && accountsToRefresh) : accountArticlesStatus?.started;
                  return !record?.conto?.isPosting ? null : (
                    <div
                      className={`articles-scroll ${accountArticles?.elements && accountArticles?.elements.length > 10 ? "" : "no-height" }`}
                      ref={ref => { containerArticlesRef.current[index] = ref;}}
                    >
                      <InfiniteScroll
                        option={{
                          wheelPropagation: true
                        }}
                        getScrollParent={() => containerArticlesRef?.current[index] }
                        pageStart={0}
                        loadMore={() => {
                          // pagina 0 la richiamiamo in onExpand
                          if (page === 0) return;
                          if (accountArticles?.hasNext && !accountArticlesStatus?.started && accountArticlesStatus?.ended) {
                            loadMoreItems(record.conto?.uuid);
                          }
                        }}
                        hasMore={!accountArticlesStatus?.started && accountArticles?.hasNext}
                        loader={accountArticlesStatus?.started && loader}
                        useWindow={false}
                      >
                        {isLoadingSpinner && loader}
                        {(record.conto?.hasChildren || newDetail.source !== "B2B")  && currentArticles?.map(el => {
                          cn++;
                          return (
                            <ArticleRowNew
                              isDocument={newDetail.source !== "B2B"}
                              key={"article-row_" + el.uuid}
                              isMonoRegime={isMonoRegime}
                              contoId={record.conto?.uuid}
                              article={el}
                              articleId={/* md5(JSON.stringify(elNoedit))*/ el.uuid}
                              // hasProbability={hasProbability}
                              onArticleDrag={val => {
                                setDroppingOn(null);
                                onDragArticleEnd(val, record?.conto);
                              }}
                              draftId={newDetail.id}
                              setOpenSplitModal={setOpenSplitModal}
                              refCurrency={newDetail?.refCurrency || "EUR"}
                              jsonCurrency={jsonCurrency}   
                              natureVal={natureVal}
                              setNatureVal={setNatureVal}  
                              setDrawerNature={setDrawerNature}
                              setCurrentItem={setCurrentItem}
                              allowDrag={allowDrag}
                              setAllowDrag={setAllowDrag}
                              lockDrag={lockDrag}
                              setLockDrag={setLockDrag}
                              draggingFrom={draggingFrom}
                              setDraggingFrom={setDraggingFrom}
                              droppingOn={droppingOn}
                              index={cn}
                              changeArticle={(val, index) => {
                                onChangeArticle(val, index);
                              }
                              }
                              currentArticles={currentArticles}
                              setCurrentArticles={setCurrentArticles}
                              setExpandedRow={setExpandedRow}
                              detailRegime={newDetail.regimeId}
                              reasonId={newDetail.reasonId}
                              isIncomeStatement={record.conto?.accountType === "INCOME_STATEMENT" && newDetail.source === "B2B"}
                            />
                          );
                        })}
                      </InfiniteScroll>
                      {newDetail.source !== "B2B" && arrayToExpand.includes(newDetail.reasonId) && <div className="articles-accordion plus">
                        <div
                          style={{ width: "2%" }}
                        >
                        &nbsp;
                        </div>
                        { newDetail.source !== "B2B" && ( newDetail.factType.toLowerCase() === "invoice" || newDetail.factType.toLowerCase() === "receipt") &&
                        <div onClick={() => addNewArticle(record.conto)}>
                          <FontAwesomeIcon icon={["fas", "plus-circle"]} style={{paddingRight: 8}}/>
                        Aggiungi imponibile
                        </div>
                        }
                      </div>}
                    </div>);
                }}}
            />
          </div>
        </div>
      }
      {openSplitModal && <SplitArticleModal
        visible={openSplitModal}
        articlesList={articlesList}
        setArticlesList={setArticlesList}
        isDocument={newDetail.source !== "B2B"}
        setOpenSplitModal={setOpenSplitModal}
        article={currentItem.currentArticle}
        contiNew={contiNew}
        currentConto={contiNew.find(el => el.uuid === currentItem.currentLine)}
        draftId={newDetail.id}
        isMonoRegime={isMonoRegime}
        changeArticle={(val, index) => {
          onChangeArticle(val, index);
        }}
        setModifiedDetail={setModifiedDetail}
        setExpandedRow={setExpandedRow}
      />}      
    </>
  );
};

export default ContiContabiliTable;
